import { Component, Input, OnInit } from '@angular/core';

declare const shaka: any;
@Component({
  selector: 'app-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.scss']
})
export class VideoPlayerComponent implements OnInit {
  @Input() videoId = 'video';
  @Input() manifestUri: string;
  @Input() thumbnailUri: string;
  @Input() width = 640;
  @Input() height = 480;

  constructor() { }

  ngOnInit(): void {
    this.initApp();
  }

  initApp() {
    shaka.polyfill.installAll();

    if (shaka.Player.isBrowserSupported()) {
      setTimeout(() => this.initPlayer(), 0);
    } else {
      console.error('Browser not supported!');
    }
  }

  initPlayer() {
    const video = document.getElementById(this.videoId);
    const player = new shaka.Player(video);
    const queryParameters = this.manifestUri.split('?')[1];

    player.addEventListener('error', this.onErrorEvent);
    player.getNetworkingEngine().registerRequestFilter(function (type, request) {

      const uri: string = request.uris[0];
      if (!uri.includes('?')) {
        request.uris[0] = request.uris[0] + `?${queryParameters}`;
      }
    });

    player.load(this.manifestUri)
      .then(function () {})
      .catch(error => { this.onError(error); });
  }

  onErrorEvent(event) {
    this.onError(event.detail);
  }

  onError(error) {
    console.error('Error code', error.code, 'object', error);
  }
}
